export var LIMIT_CHILDREN = 1000;
export var FOLDER_MODELS_OPENED_KEY = 'FOLDER_MODELS_OPENED_KEY';
export var PANEL_WIDTH = 350;